import React from 'react';
import { Select } from 'antd';
import { Button } from '@progress/kendo-react-buttons'
import services from '../../../services';
import { DownCircleTwoTone } from '@ant-design/icons'
import { toast } from 'react-toastify';
import InstructionMessage from '../../VidimaModule/Modal/InstructionMessage';
const { Option } = Select;

let responseData = {}

const message = "Nesta área serão definidas as regras de conta corrente a serem aplicadas por estatuto de entidade. Nestas serão estabelecidas as definições que serão validadas na execução automática de operações."

class Nivel1Form extends React.Component {

  constructor() {
    super()

    this.state = {
      filters: {
        Filters: null,
        SortBy: "",
        IsSortTypeDESC: false,
        IsPagination: false,
        Page: 2,
        PageSize: 2
      },
      submitData: {
        "idTipoAcao": [],
        "idTipoConta": [],
        "idProduto": [],
        "idCategoriaProduto": [],
        "idEstado": [],
        "idTipoMovimento": [],
        "idMovimento": []
      },
      submitDataOff: {
        "idTipoAcao": [],
        "idTipoConta": [],
        "idEstado": [2],
        "idProduto": [],
        "idCategoriaProduto": [],
        "idTipoMovimento": [],
        "idMovimento": []
      },
      movementId: null,
      codEstatuto: '',
      // selectedTipoDeMovimento : '',
      estatuto: [],
      categorias: [],
      tipoDeConta: [],
      produto: [],
      categoria: [],
      tipoDeMovimento: [],
      movements: [],
      selectedMovements: []
    }
  }

  componentDidMount() {

    (async () => {
      let Filters = {
        CurrentAccount: true
      }
      let filters = {...this.state.filters, Filters}
      const estatuto = await services.apiCall.requestApi("Estatuto/GetAll", filters, 'post')
      this.setState({ estatuto });
      console.log("ESTATUTOS" , estatuto)
    })();

    (async () => {
      const categorias = await services.apiCall.requestApi("allservice/Categorias/GetAll", this.state.filters, 'post')
      this.setState({ categorias });
    })();

    (async () => {
      const tipoDeConta = await services.apiCall.requestApi("allservice/TipoConta/GetAll", this.state.filters, 'post')
      this.setState({ tipoDeConta });
    })();

    (async () => {
      const produto = await services.apiCall.requestApi("allservice/familiaProduto/GetAll", this.state.filters, 'post')
      this.setState({ produto });
    })();

    (async () => {
      const categoria = await services.apiCall.requestApi("allservice/CategoriaProduto/GetAll", this.state.filters, 'post')
      this.setState({ categoria });
    })();

    (async () => {
      const tipoDeMovimento = await services.apiCall.requestApi("allservice/TipoMovimento/GetAll", this.state.filters, 'post');
      console.log("tipoMov",tipoDeMovimento);
      const newTipo= Array.isArray(tipoDeMovimento) && tipoDeMovimento.length>0 && tipoDeMovimento.filter(item=>item.idTipoMovimento!==13);
      this.setState({ tipoDeMovimento:newTipo },()=>{
        console.log("afterrrrrrr")
        this.movimentoWithoutFilter();
      });
    })();
  }

  handleEstatutoChange(codEstatuto) {
    if (codEstatuto) {
      this.setState({
        codEstatuto
      }, async () => {
        await this.getEstatutoRules(codEstatuto)     
      })
    } else {
      return
    }
  }

  getEstatutoRules = async (codEstatuto) => {
    const filters = {
      Id: codEstatuto,
    };

    const response = await services.apiCall.requestApi("SIVDP/SaveRule/GetById", filters, 'post')
    if (response) {
      if(response.idRegra) {
        let { submitData, submitDataOff } = { ...this.state }
        let data = {} 
        let IDRegra 
        data["IDRegra"] = response.idRegra
        IDRegra = response.idRegra

        Object.keys(submitData).map(key => {
          //response[key] 
          if(key === "idTipoAcao" ||
          key === "idTipoConta" ||
          key === "idCategoriaProduto" ||
          key === "idTipoMovimento") {
            if(response[key] === null || response[key] === "") {
              data[key] = []
            }
            else {
              data[key] = this.changeFormat(response[key], "number", "toArray")
            }
          }

          else if(key === "idProduto") {
            if(response[key] === null || response[key] === "") {
              data[key] = []
            }
            else {
              data[key] = this.changeFormat(response[key], "NaN", "toArray")
            }
          }
          else if(key === "idMovimento") {
            if(!response[key]) {
              data[key] = []
            }
            else if (Array.isArray(response[key])) {
              data[key] = response[key]
            }
          }
          else {
            data[key] = response[key]
          }
        })
        //data object ready for submitData
        console.log("777 data", data)  
        this.setState({ 
          submitData: data, 
          submitDataOff,
          IDRegra 
        },()=>{
          console.log("Submit Data",submitData)
          this.movimentoWithFilter('submitData')
        })
      }
    }
    console.log("🚀 ~ file: Nivel1.js ~ line 78 ~ Nivel1Form ~ response", response);
  }

  movimentoWithoutFilter = async()=>{
    const filters = {
      Filters: null,
      SortBy: "",
      IsSortTypeDESC: true,
      IsPagination: false,
      Page: 2
    }
    console.log("hiiii 123454")
    const movements = await services.apiCall.requestApi("allservice/MovimentoDetails/GetAll", filters, 'post')
    this.setState({ selectedMovements: movements })
    console.log("🚀 ~ file: Nivel1.js ~ line 83 ~ Nivel1Form ~ movements", movements);
  }

  movimentoWithFilter = async (type) => {
    const filters = {...this.state.filters}
    filters.Filters = null
    const movements = await services.apiCall.requestApi("allservice/MovimentoDetails/GetAll", filters, 'post')
    this.setState({selectedMovements : movements})
    console.log("🚀 ~ file: Nivel1.js ~ line 83 ~ Nivel1Form ~ movements", movements);
  }

  //target - array or string
  changeFormat = (target, type, to) => {
    if(to === "toString") {
      if(type === "number")
      return target.join()

      else if(type === "NaN")
      return target.join(",")
    }
    else {
      if(type === "number") {
        let arr = target.split(",")
        arr.map((num, index) => {
          arr[index] = +num
        })
        return arr
      }
      else if(type === "NaN") {
        let arr = target.split(",")
        return arr
      }
    }
  }

  handleGraverRegra = async () => {
    let data = {}
    let dataOff = {}
    let { submitData, codEstatuto, submitDataOff } = this.state
    if (codEstatuto) {
      Object.keys(submitData).map(_k => {
        let newKey = _k.substr(0, 2).toUpperCase() + _k.substr(2, _k.length - 1);
        let arr = submitData[_k]
        //number changeFormatToString
        if(_k === "idTipoConta" || 
        _k === "idCategoriaProduto" ||
        _k === "idTipoMovimento" ||
        _k === "idTipoAcao") {
          data[newKey] = this.changeFormat(arr, "number", "toString")
        }

        //NaN changeFormatToString
        else if(_k === "idProduto" ) {
          data[newKey] = this.changeFormat(arr, "NaN", "toString")
        }

        //not to change format
        else if(_k === "idMovimento" ) {
          data[newKey] = arr
        }
      })
      data["IDEstatuto"] = +codEstatuto
      if(this.state.IDRegra) {
        data["IDRegra"] = this.state.IDRegra
      }
      let res = await services.apiCall.requestApi('SIVDP/ProcInsertRuleNigraslvl1', data, 'post');
      if (res) {
        this.getEstatutoRules(codEstatuto)
      }
      this.movimentoWithFilter('submitData')
    } 
    else {
      toast.error("Selecione o estatuto para salvar")
    }
  }

  checkForNULL = (data) => {
    Object.keys(data).map(key => {
      if(data[key] === "") {
        data[key] = null
      }
    })
    return data
  }

  handleCancel = () => {
    this.props.history.push({
      pathname: "/conta_corrente"
    })
  }

  addMovement = () => {
    if (this.state.movementId === null) {
      return;
    } else {
      let stateData = { ...this.state.submitData }
      let index = stateData['idMovimento'].indexOf(+this.state.movementId)
      if (index > -1) {
        return;
      }
      stateData['idMovimento'].push(+this.state.movementId)
      this.updateSubmitDataOff(+this.state.movementId, 'idMovimento')
      this.setState({ submitData: stateData, movementId: null })
    }
  }

  removeMovement = (id) => {
    let { selectedMovements } = this.state;
    selectedMovements = selectedMovements.filter((movement) => movement.idMovimento !== id);
    this.setState({ selectedMovements })
    let stateData = { ...this.state.submitData }
    let index = stateData['idMovimento'].indexOf(id)
    if (index > -1) {
      stateData['idMovimento'].splice(index, 1)
      this.updateSubmitDataOff(id, 'idMovimento')
    }
    this.setState({ submitData: stateData })
  }

  handleChange = (type, id) => {
    let { submitData , submitDataOff} = { ...this.state }
    if (type === 'idMovimento') {
      this.setState({ movementId: id })
    }else if(type === 'idTipoMovimento'){
        submitData[type] = [id]
        submitDataOff[type] = responseData[type] || []
        this.setState({submitData,submitDataOff})
    } else {
      let index = submitData[type].indexOf(id)

      if (index > -1) {
        submitData[type].splice(index, 1) //remove from insert data

        // working for updating the checkbox
        this.updateSubmitDataOff(id, type)

      } else {
        submitData[type].push(id)
        this.updateSubmitDataOff(id, type)
      }
      this.setState({ submitData},()=>{
        if((type === 'idTipoAcao' || type === 'idProduto' || type === 'idTipoConta') && 
        submitData.idTipoAcao.length > 0 || submitData.idProduto.length > 0 || submitData.idTipoConta.length > 0){
          this.movimentoWithFilter('submitData');
        }
      })
    }
  }

  updateSubmitDataOff = (id, type) => {
    if (Object.keys(responseData).length > 0) {
      let { submitDataOff } = { ...this.state }
      let index3 = responseData[type].indexOf(id)
      
      if (index3 > -1) {
        let index2 = submitDataOff[type].indexOf(id)
        
        if (index2 > -1) {
          submitDataOff[type].splice(index2, 1)
        } else {
          submitDataOff[type].push(responseData[type][index3])
        }
      }
      this.setState({ submitDataOff},()=>{
        if((type === 'idTipoAcao' || type === 'idProduto' || type === 'idTipoConta') &&
            (submitDataOff.idTipoAcao.length > 0 || submitDataOff.idProduto.length > 0 || submitDataOff.idTipoConta.length > 0)){
          this.movimentoWithFilter('submitDataOff');
        }
      })
    }
  }

  render() {
    // console.log("Datattatatat",this.state.submitData, this.state.submitDataOff)
    const { estatuto, categorias, tipoDeConta, produto, categoria, tipoDeMovimento, selectedMovements } = this.state;

    return (
      <div className="container-fluid pb-5">
        <div className="p-3 bg-white border rounded">
          <div>
            <InstructionMessage messageFor="nivel" message={ message } />
          </div>
          <label>Estatuto</label>
          <div className="row" id="sticky-seachmenu">
            <div className="col-auto position-relative">
              <Select
                showSearch
                optionFilterProp="children"
                maxTagTextLength={ 3 }
                suffixIcon={ <DownCircleTwoTone /> }
                placeholder="Selecione o estatuto"
                className="estatoSelect"
                style={ { width: '300px' } }
                value={ this.state.codEstatuto }
                onChange={ (e) => this.handleEstatutoChange(e) }
              >
                <Option value="" >Selecione o estatuto</Option>
                { (estatuto && !!estatuto.length) && estatuto.map((item, index) => (
                  <Option key={ index } value={ +item.codEstatuto }>{ item.estatuto }</Option>
                )) }
              </Select>
              <div class="drop-icon">
                <i class="fas fa-chevron-down"></i>
              </div>
            </div>
            <div className="pl-0">
              <Button className="mr-2 btn-ivdp-primary btn-theme k-primary" onClick={ () => this.handleGraverRegra() } >Gravar Regra</Button>
            </div>
            <div className="col-auto pl-0">
              <Button onClick={ () => this.handleCancel() } className="btn-ivdp-secondary">Cancelar</Button>
            </div>
          </div>
          { (categorias && !!categorias.length) && (
            <div className="mt-3">
              <h4>Tipo de Ação</h4>
              <div className="p-3 border rounded">
                <div className="row">
                  {
                    categorias.map((item, index) => (
                      <div className="col-6" key={ index }>
                        <div className="custom-control custom-switch">
                          <input 
                            type="checkbox" 
                            checked={ this.state.submitData['idTipoAcao'].find(el => el == item.idCategoria) !== undefined ? true : false } 
                            onChange={ () => this.handleChange('idTipoAcao', item.idCategoria) } 
                            className="custom-control-input" 
                            id={ `checkboxCategorias${item.idCategoria}` } 
                          />
                          <label className="custom-control-label" htmlFor={ `checkboxCategorias${item.idCategoria}` }>{ item.descricao }</label>
                        </div>
                      </div>
                    ))
                  }
                </div>
              </div>
            </div>
          ) }
          { (tipoDeConta && !!tipoDeConta.length) && (
            <div className="mt-3">
              <h4>Tipo de Conta</h4>
              <div className="p-3 border rounded">
                <div className="row">
                  {
                    tipoDeConta.map((item, index) => (
                      <div className="col-6" key={ index }>
                        <div className="custom-control custom-switch">
                          <input type="checkbox" checked={ this.state.submitData['idTipoConta'].find(el => el == item.idTipoConta) !== undefined ? true : false } onChange={ () => this.handleChange('idTipoConta', item.idTipoConta) } className="custom-control-input" id={ `tipoDeConta${item.idTipoConta}` } />
                          <label className="custom-control-label" htmlFor={ `tipoDeConta${item.idTipoConta}` }>{ item.descricao }</label>
                        </div>
                      </div>
                    ))
                  }
                </div>
              </div>
            </div>
          ) }
          { (produto && !!produto.length) && (
            <div className="mt-3">
              <h4>Produto</h4>
              <div className="p-3 produtoPadding border rounded">
                <div className="products-holder p-3">
                  <div className="row">
                    {
                      produto.map((item, index) => (
                        <div className="col-6" key={ index }>
                          <div className="custom-control custom-switch">
                            <input type="checkbox" checked={ this.state.submitData['idProduto'].find(el => el == item.codProduto) !== undefined ? true : false } onChange={ () => this.handleChange('idProduto', item.codProduto) } className="custom-control-input" id={ `produto${item.codProduto}` } />
                            <label className="custom-control-label" htmlFor={ `produto${item.codProduto}` }>{ item.nomePropduto }</label>
                          </div>
                        </div>
                      ))
                    }
                  </div>
                </div>
              </div>
            </div>
          ) }
          { (categoria && !!categoria.length) && (
            <div className="mt-3">
              <h4>Categoria</h4>
              <div className="p-3 border rounded">
                <div className="row">
                  {
                    categoria.map((item, index) => (
                      <div className="col-3" key={ index }>
                        <div className="custom-control custom-switch">
                          <input type="checkbox" checked={ this.state.submitData['idCategoriaProduto'].find(el => el == item.idCategoriaProduto) !== undefined ? true : false } onChange={ () => this.handleChange('idCategoriaProduto', item.idCategoriaProduto) } className="custom-control-input" id={ `categoria${item.idCategoriaProduto}` } />
                          <label className="custom-control-label" htmlFor={ `categoria${item.idCategoriaProduto}` }>{ item.descriaco }</label>
                        </div>
                      </div>
                    ))
                  }
                </div>
              </div>
            </div>
          ) }
          { (tipoDeMovimento && !!tipoDeMovimento.length) && (
            <div className="mt-3">
              <h4>Tipo de Movimento</h4>
              <div className="p-3 border rounded">
                <div className="row">
                  {
                    tipoDeMovimento.map((item, index) => (
                      <div className="col-3" key={ index }>
                        <div className="custom-control custom-switch">
                          <input type="checkbox" checked={ this.state.submitData['idTipoMovimento'][0] == item.idTipoMovimento ? true : false } onChange={ () => this.handleChange('idTipoMovimento', item.idTipoMovimento) } className="custom-control-input" id={ `checkboxTipoDeMovimento${item.idTipoMovimento}` } />
                          <label className="custom-control-label" htmlFor={ `checkboxTipoDeMovimento${item.idTipoMovimento}` }>{item.tipoMovimento}</label>
                        </div>
                      </div>
                    ))
                  }
                </div>
              </div>
            </div>
          ) }
          <div className="mt-3">
            <h4>Movimentos</h4>
            <div className="p-3 border rounded">
              <div className="p-3 border rounded d-flex align-items-center justify-content-between mb-3">
                <span>Adicione movimentos a serem relacionados com o estatuto</span>
              </div>
              { (selectedMovements && !!selectedMovements.length && this.state.submitData && !!this.state.submitData['idMovimento'].length) && this.state.submitData['idMovimento'].map((item, index) => (
                <div className="p-3 border rounded mb-3" key={ index }>
                  <div className="row align-items-center">
                    <div className="col-4">Movimento: { (selectedMovements && !!selectedMovements.length) && selectedMovements.filter(el => el.idMovimento == item)[0].codMovimento }</div>
                    <div className="col">Descrição: { (selectedMovements && !!selectedMovements.length) && selectedMovements.filter(el => el.idMovimento == item)[0].movimento }</div>
                    <div className="col-auto">
                      <Button className="btn-ivdp-primary btn-theme k-primary" onClick={ () => this.removeMovement(item) }>Remover Movimento</Button>
                    </div>
                  </div>
                </div>
              )) }
              <div className="p-3 border rounded mb-3">
                <div className="row">
                  <div className="col-auto position-relative">
                    <Select
                      showSearch
                      optionFilterProp="children"
                      suffixIcon={ <DownCircleTwoTone /> }
                      placeholder="Selecione o movimento"
                      style={ { width: '300px' } }
                      className="estatoSelect"
                      value={ this.state.movementId || "" }
                      onChange={ (e) => this.handleChange('idMovimento', e) }
                    >
                      <Option disabled value="" >Selecione o movimento</Option>
                      { (selectedMovements && !!selectedMovements.length) && selectedMovements.map((item, index) => (
                        <Option key={ index } value={ item.idMovimento }>{ item.movimento }</Option>
                      )) }
                    </Select>

                    <div class="drop-icon">
                      <i class="fas fa-chevron-down"></i>
                    </div>
                  </div>

                  <Button onClick={ () => this.addMovement() } className="btn-ivdp-primary btn-theme ml-3 k-primary">Adicionar Movimento</Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

}

export default Nivel1Form;